var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewPricingCheck = function SvgNewPricingCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    d: "M8.049 15.041a.75.75 0 0 0 1.06 0l7.718-7.717a.75.75 0 0 0-1.06-1.061L8.578 13.45 5.11 9.98a.75.75 0 1 0-1.06 1.061z"
  })));
};
export default SvgNewPricingCheck;